module.exports = __webpack_public_path__ + "static/list-895cec5bccb54e14ae7dd63809dd89a4.jpg";